/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Emailverificationpending2Inputs */

const en_emailverificationpending2 = /** @type {(inputs: Emailverificationpending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email Verification Pending`)
};

const de_emailverificationpending2 = /** @type {(inputs: Emailverificationpending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Verifizierung ausstehend`)
};

/**
* | output |
* | --- |
* | "Email Verification Pending" |
*
* @param {Emailverificationpending2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const emailverificationpending2 = /** @type {((inputs?: Emailverificationpending2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Emailverificationpending2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_emailverificationpending2(inputs)
	return de_emailverificationpending2(inputs)
});
export { emailverificationpending2 as "emailVerificationPending" }